/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import './Badge.scss';

@observer
class Badge extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const value = this.props.number;
		return (
			<span className='explore__badge'>
				{value}
			</span>
		);
	}
}

Badge.propTypes = {
	number: PropTypes.number
};

Badge.defaultProps = {
	number: 0
};

export default Badge;



// WEBPACK FOOTER //
// ./src/js/components/badge/Badge.js